import client from "../api/client";

export const getProfile = () => {
  return client('/api/users/profile').then(({ data }) => data.data);
};

export const editProfile = (values) => {
  return client('/api/users/profile', {method: 'put', body: values}).then(({ data }) => data.data);
};

export const toggleActiveAccount = (id) => {
  return client(`/api/users/${id}/toggle-active`, {method: 'post', body: {}}).then(({ data }) => data.data);
};

export const getList = () => {
  return client('/api/users').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/users/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/users/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/users', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/users/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useUserService () {
  return {
    getProfile,
    editProfile,
    getList,
    addEditModel,
    getDetail,
    delModel,
    toggleActiveAccount,
  };
}
